import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { getAccessToken } from "../context/auth/tokenStore";
import { PUSHER_APP_KEY, PUSHER_APP_CLUSTER, API_BASE_URL } from "../constants/env";

declare global {
  interface Window {
    Pusher: typeof Pusher;
  }
}

window.Pusher = Pusher;

const key = PUSHER_APP_KEY;
const cluster = PUSHER_APP_CLUSTER;
const authUrl = `${API_BASE_URL}/broadcasting/auth`;

export function createEcho(): Echo<"pusher"> | null {
  if (!key || !cluster) return null;
  return new Echo<"pusher">({
    broadcaster: "pusher",
    key,
    cluster,
    forceTLS: true,
    authEndpoint: authUrl,
    auth: {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    },
  });
}
